<script setup>
/* Abschnitte einer Spielerliste mit Überschrift je Sortierung (Mannschaftsteil, Anfangsbuchstabe oder
   Jahrgang); bei der flachen Sortierung "date" ohne Überschrift. Die Zeile je Spieler kommt als
   Slot "member" von der Seite (PlayerRow bzw. TransferredRow). */
import { useI18n } from 'vue-i18n';

defineProps({
  sections: { type: Array, required: true },
  sort: { type: String, required: true },
});
const { t } = useI18n();

function sectionTitle(sort, section) {
  if (sort === 'az') return section.key;
  if (sort === 'age') return section.key || t('squad.ageUnknown');
  return t(`positionGroup.${section.key}`);
}
</script>

<template>
  <template v-for="section in sections" :key="section.key">
    <div v-if="sort !== 'date'" class="pos-section">
      <!-- Zahl in Klammern direkt am Namen, gleiche Schrift und Farbe. Screenreader bekommen "Winger, 10 players". -->
      <span class="ps-title" aria-hidden="true">{{ sectionTitle(sort, section) }} ({{ section.members.length }})</span>
      <span class="ps-sr">{{ sectionTitle(sort, section) }}, {{ $t('squad.playerCount', { count: section.members.length }) }}</span>
    </div>
    <slot v-for="p in section.members" :key="p.id" name="member" :player="p" />
  </template>
</template>
